<app-preloader *ngIf="isLoading"></app-preloader>
<!-- MODAL PARA SELECCIONAR DISTRIBUIDORES-->
<div class="modal">
  <a class="close" (click)="close ()">Cerrar</a>
  <h1>Seleccionar distribuidores</h1>
  <div class="seleccionarDistribuidores">
    <form>
      <div class="filters">
        <div class="wrapperG3">
          <div class="controlWrapper">
            <label>Nombre</label>
            <app-input [data]="searchName" (textSearch)="filter($event, 'name')" [resetInput]="reset"></app-input>
          </div>
          <div class="controlWrapper">
            <label>Grupo</label>
            <app-select [options]="groups" [placeholder]="'Buscar por grupo'" [resetSelect]="reset"
              (optionSelected)="filter($event, 'groupName')"></app-select>
          </div>
          <div class="controlWrapper">
            <label>Sucursal</label>
            <app-select [options]="branches" [placeholder]="'Buscar por sucursal'" [resetSelect]="reset"
              (optionSelected)="filter($event, 'branchName')"></app-select>
          </div>
        </div>
        <div class="wrapperG3">
          <label class="switch gapTop">
            <input type="checkbox" [checked]="showOnlySelected" (change)="toggleOnlySelectedDealers($event)" />
            <span class="knob"></span>
            <span class="base"></span>
            <span class="description">Solo seleccionados</span>
          </label>
          <div class="filterActions">
            <button class="secondary clear" (click)="resetFilters()" tp="Limpiar filtros">
              Limpiar filtros
            </button>
            <button class="primary search" (click)="search()" tp="Buscar">Buscar</button>
          </div>
        </div>
      </div>

      <!-- Tabla para listado de notificaciones -->
      <div class="customTable seleccionarDistribuidores">
        <div class="header">
          <div class="cell seleccion">
            @if (dealerIds.length == 0) {
            <label class="checkboxWrapper">
              <input (click)="checkAllDealers($event)" type="checkbox" />
              <span class="checkmark"></span>
            </label>
            } @else if ( dealerIds.length > 0 && dealerIds.length < dealersList.length) { <label
              class="checkboxWrapper">
              <a (click)="checkAllDealers($event)" class="checkmark undefined"></a>
              </label>
              } @else {

              <label class="checkboxWrapper">
                <input (click)="uncheckAllDealers($event)" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              }
          </div>
          <div class="cell nombre">Nombre</div>
          <div class="cell grupo">Grupo</div>
          <div class="cell sucursal">Sucursal</div>
        </div>

        <div class="rowsWrapper">

          @for (dealer of dealersList; track dealer){
          <div class="row">
            <div class="cell seleccion">
              <label class="checkboxWrapper">
                <input [checked]="dealer.isChecked" (click)="addDealer($event, dealer)" type="checkbox" name="item" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="cell nombre">
              {{ dealer.dealerName }}
            </div>

            <div class="cell grupo">
              {{ dealer.groupName }}
            </div>
            <div class="cell sucursal">
              
              <ul>
                <li>{{ dealer.branchName }}</li>
              </ul>
              
            </div>
          </div>
        }
        </div>
      </div>
      <div class="itemsInfo">
        {{ showAmount(dealerIds) }} de
        {{ showAmount(dealersList) }} seleccionados
      </div>

      <!-- Acciones para modal condición -->
      <div class="actions">
        <div class="wrapper">
          <button (click)="close()" type="button" class="secondary">
            Cancelar
          </button>
          <button (click)="closeAndSave()" type="submit" class="primary">
            Aceptar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>